const images = {
  noImage: require('~/assets/images/no-image.png'),
  rewardImage: require('~/assets/images/coin-img.png'),
}

export default images;